import { createRouter, createWebHashHistory, RouteRecordRaw, RouterOptions } from 'vue-router';
import MainLayout from '@/components/layout/MainLayout.vue';
import EmptyLayout from '@/components/layout/EmptyLayout.vue';
import HomeView from '../views/HomeView.vue';
import ForgetPassword from '@/views/LoginRegister/ForgetPassword.vue'
import PaymentMethod from '@/views/PaymentMethod.vue'
import PaymentMethodList from '@/views/PaymentMethodList.vue'

import PaymentMethodPage from '@/views/PaymentMethodPage.vue';


const routes = [
  {
    path: '/',
    component: MainLayout, // 用 MainLayout 作为主布局
    children: [
      {
        path: '',
        name: 'home',
        component: HomeView
      },
      {
        path: 'ologin',
        name: 'ologin',
        component: () => import('../views/LoginRegister/ologin.vue')
      },
      {
        path: 'shop', // 正确
        name: 'shop',
        component: () => import('../views/shopPage/ShopView.vue')
      },
      {
        path: 'shopSearch',
        name: 'shopSearch',
        component: () => import('../views/shopPage/ShopViewSearch.vue')
      },
      {
        path: 'about',
        name: 'about',
        component: () => import('../views/AboutView.vue')
      },
      {
        path: 'cate',
        name: 'cate',
        component: () => import('../views/Shopping/CartView.vue')
      },
      {
        path: 'checkout',
        name: 'checkout',
        component: () => import('../views/Shopping/Checkout.vue')
      },
      {
        path: 'orderSuccess',
        name: 'orderSuccess',
        component: () => import('../views/Shopping/OrderSuccess.vue')
      },
      {
        path: 'paysafe',
        name: 'paysafe',
        component: () => import('../views/PaySafePage/safepaypage.vue')
      },
      {
        path: 'category/:slug',
        name: 'category',
        component: () => import('../views/CategoryView.vue')
      },
      {
        path: 'purchase',
        name: 'productPurchase',
        component: () => import('../views/ProductPurchase/ProductPurchaseView.vue'),
        props: true
      },
      {
        path: 'merchant',
        name: 'merchant',
        component: () => import('../views/Merchant_products/Store.vue'),
        props: true
      },
      {
        path: 'order-OrderList',
        name: 'OrderList',
        component: () => import('../views/order/OrderList.vue')
      },
      {
        path: 'order/:orderId',
        name: 'OrderDetails',
        component: () => import('../views/order/OrderDetail.vue'),
        props: (route) => ({
          orderId: route.params.orderId,
          price: route.query.price,
          date: route.query.date,
          quantity: route.query.quantity
        })
      },
      {
        path: 'forget-password',
        name: 'ForgetPassword',
        component: ForgetPassword
      },
      {
        path: 'tender',
        name: 'TenderPage',
        component: () => import('../views/TenderPage.vue')
      },
      {
        path: 'renovation-tender/:id',
        name: 'RenovationTenderDetail',
        component: () => import('../views/tender/RenovationTenderDetail.vue'),
        props: true
      },
      {
        path: '/tender/submit/:id',
        name: 'TenderSubmit',
        component: () => import('../views/tender/tenderSubmit.vue'),
        props: true // 将路由参数传递给 tenderSubmit 组件
      },
      {
        path: 'myaccount',
        name: 'MyAccount',
        component: () => import('../views/myAccount/MyAccount.vue'),
      },
      {
        path: 'messages',
        name: 'messagesNotification',
        component: () => import('../views/PersonCenter/MessagesView.vue'),
      },
      {
        path: 'tender-list',
        name: 'TenderList',
        component: () => import('../views/tender/tenderList.vue')
      },
      {
        path: 'personTender-list/:type?',
        name: 'PersonTenderList',
        component: () => import('../views/tender/personTenderList.vue'),
        props: true
      },      {
        path: '/profile-information',
        name: 'ProfileInformation',
        component: () => import('../views/PersonCenter/ProfileInformation.vue')
      },
      {
        path: '/company-information',
        name: 'CompanyInformation',
        component: () => import('../views/PersonCenter/CompanyInformation.vue')
      },
      {
        path: '/point',
        name: 'point',
        component: () => import('../views/PersonCenter/point.vue')
      },
      {
        path: '/point-detail',
        name: 'pointDetail',
        component: () => import('../views/PersonCenter/pointDetail.vue'),
        props: (route) => ({ id: route.query.id })
      },
      {
        path: '/merchant-information',
        name: 'MerchantInformation',
        component: () => import('../views/PersonCenter/MerchantInformation.vue')
      },
      {
        path: '/profile-address',
        name: 'EditAddress',
        component: () => import('../views/PersonCenter/EditAddress.vue')
      },
      {
        path: '/building-materials',
        name: 'BuildingMaterials',
        component: () => import('../views/category/building-materials.vue')
      },
      {
        path: '/tools',
        name: 'Tools',
        component: () => import('../views/category/tools.vue')
      },
      {
        path: '/doors-windows',
        name: 'DoorsWindows',
        component: () => import('../views/category/doors-windows.vue')
      },
      {
        path: '/furniture',
        name: 'Furniture',
        component: () => import('../views/category/furniture.vue')
      },
      {
        path: '/lighting',
        name: 'Lighting',
        component: () => import('../views/category/lighting.vue')
      },
      {
        path: '/electrical',
        name: 'Electrical',
        component: () => import('../views/category/electrical.vue')
      },
      {
        path: '/allDepartments',
        name: 'AllDepartments',
        component: () => import('../views/AllDepartments/allDepartments.vue')
      },
      {
        path: '/titlevel',
        name: 'titlevel',
        component: () => import('../views/category_level3/titlevel.vue')
      },
      {
        path: '/installation',
        name: 'installation',
        component: () => import('../views/allservices/installation.vue')
      },
      {
        path: '/delivery',
        name: 'delivery',
        component: () => import('../views/allservices/delivery.vue')
      },
      {
        path: '/design',
        name: 'design',
        component: () => import('../views/allservices/design.vue')
      },
      {
        path: '/profile-buyNowSetting',
        name: 'BuyNowSetting',
        component: () => import('../views/PersonCenter/BuyNowSetting.vue')
      },
      {
        path: '/coupons',
        name: 'Coupons',
        component: () => import('../views/PersonCenter/Coupons.vue')
      },
      {
        path: '/favorite',
        name: 'Favorite',
        component: () => import('../views/PersonCenter/Favorite.vue')
      },
      {
        path: '/invitationCode',
        name: 'invitationCode',
        component: () => import('../views/PersonCenter/InvitationCode.vue')
      },
      {
        path: '/merchantsEdit',
        name: 'MerchantsEdit',
        component: () => import('../views/PersonCenter/MerchantsEdit.vue')
      },
      {
        path: '/payment/list',
        name: 'PaymentMethodList',
        component: PaymentMethodList
      },
      {
        path: '/payment/add',
        name: 'PaymentMethod',
        component: PaymentMethod
      },
      {
        path: '/waitPayOrder',
        name: 'WaitPayOrder',
        component: () => import('../views/order/waitPayOrder.vue')
      },
      {
        path: '/orderPage',
        component: () => import('../views/order/OrderPage.vue'),
        meta: { breadcrumb: 'Home' },
        children: [
          {
            path: '',
            name: 'OrderList',
            component: () => import('../views/order/OrderList.vue'),
            meta: { breadcrumb: 'Order List' }
          },
          {
            path: 'order/:orderId',
            name: 'OrderDetails',
            component: () => import('../views/order/OrderDetail.vue'),
            meta: { breadcrumb: 'Order Details' }
          }
        ]
      },

      {
        path: '/paymentPage',
        component: PaymentMethodPage,
        meta: { breadcrumb: 'Home' },
        children: [
          {
            path: '',
            name: 'PaymentMethodList',
            component:PaymentMethodList,
            meta: { breadcrumb: 'PaymentMethod List' }
          },
          {
            path: '/payment/add',
            name: 'PaymentMethod',
            component: PaymentMethod,
            meta: { breadcrumb: 'PaymentMethod' }
          }
        ]
      },

      {
        path: '/ReleaseTaskDetail',
        name: 'ReleaseTaskDetail',
        component: () => import('../views/ReleaseTasks/ReleaseTaskDetail.vue')
      },
      {
        path: '/ReleaseTaskList',
        name: 'ReleaseTaskList',
        component: () => import('../views/ReleaseTasks/ReleaseTaskList.vue')
      },
      {
        path: '/companyInfo',
        name: 'CompanyInfo',
        component: () => import('../views/footer/companyInfo.vue')
      },
      {
        path: '/installService',
        name: 'InstallService',
        component: () => import('../views/footer/install_service.vue')
      },
      {
        path: '/deliveryService',
        name: 'DeliveryService',
        component: () => import('../views/footer/delivery_service.vue')
      },
      {
        path: '/financingService',
        name: 'FinancingService',
        component: () => import('../views/footer/financing_service.vue')
      },
      {
        path: '/responsibility',
        name: 'Responsibility',
        component: () => import('../views/footer/responsibility.vue')
      },
      {
        path: '/returnPolicy',
        name: 'ReturnPolicy',
        component: () => import('../views/footer/returnPolicy.vue')
      },
      {
        path: '/careers',
        name: 'Careers',
        component: () => import('../views/footer/careers.vue')
      },
      {
        path: '/policy',
        name: 'Policy',
        component: () => import('../views/footer/policy.vue')
      },
      {
        path: '/termsUse',
        name: 'TermsUse',
        component: () => import('../views/footer/termsUse.vue')
      },
  {
    path: '/merchants-join',
    component: EmptyLayout,
    children: [
      {
        path: '',
        name: 'MerchantsJoin',
        component: () => import('@/views/LoginRegister/MerchantsJoin.vue')
      },
      {
        path: '/companyregister',
        name: 'CompanyRegister',
        component: () => import('@/views/LoginRegister/CompanyRegister.vue')
      },
      {
        path: '/companyregister1',
        name: 'CompanyRegister1',
        component: () => import('@/views/LoginRegister/CompanyRegister1.vue')
      },
      {
        path: '/companyregister2',
        name: 'CompanyRegister2',
        component: () => import('@/views/LoginRegister/CompanyRegister2.vue')
      },
      {
        path: '/companyregister3',
        name: 'CompanyRegister3',
        component: () => import('@/views/LoginRegister/CompanyRegister3.vue')
      },
      {
        path: '/companyregister4',
        name: 'CompanyRegister4',
        component: () => import('@/views/LoginRegister/CompanyRegister4.vue')
      },
      {
        path: '/companyregister5',
        name: 'CompanyRegister5',
        component: () => import('@/views/LoginRegister/CompanyRegister5.vue')
      },
      {
        path: '/merchantregister',
        name: 'MerchantRegister',
        component: () => import('@/views/LoginRegister/MerchantRegister.vue')
      }
    ]
  }

    ]
  },
  {
    path: '/privacyPolicyCn',
    name: 'PrivacyPolicyCn',
    component: () => import('../views/footer/privacyPolicyCn.vue')
  },
  {
    path: '/privacyPolicyEn',
    name: 'PrivacyPolicyEn',
    component: () => import('../views/footer/privacyPolicyEn.vue')
  }
] as RouteRecordRaw[];

const router = createRouter({
  history: createWebHashHistory(),
  routes
} as RouterOptions);

export default router;
